import { Activity, Circle } from 'react-feather'
import worklistIcon from "../../assets/images/icons/worklist.png"

export default [
  {
    id: 'StudyList',
    title: 'Study List',
    icon: <><img
            src={worklistIcon}
            width="23"
            height="23"
            className="worklistIcon"
            style={{
              marginRight: "1.1rem",
              cursor: "pointer"
            }}
          />
        </>,
    badge: 'light-warning',
    navLink: '/study-list',
    action: 'manage',
    resource: 'study-list'
  }
]
